/*
 * THIS FILE IS GENERATED — DO NOT EDIT.
 *
 * Source:    swagger30-auth.json
 * Generator: bin/generateEndpointOperations.ts
 * Regen:     npm run generate:clients (from sst/)
 */

import type {
  GeotabLoginRequest,
  GeotabLoginResponse,
  IsaacLoginRequest,
  IsaacLoginResponse,
  PTTWakeUpRequest,
  PlatformScienceLoginRequest,
  PlatformScienceLoginResponse,
  QrLoginRedeemRequest,
  QrLoginRedeemResponse,
  QrLoginTokenResponse,
  ReviveDeviceRequest,
  TokenExchangeRequest,
  TokenExchangeResponse,
  UpdateAccountRequest,
  UpdatePushNotificationRequest,
  UserInfoResponse,
} from "./data-contracts";
import type { Transport } from "../transport";

/**
 * `PATCH /auth/accounts/{accountId}`
 *
 * Account updated successfully
 */
export function patchAccounts(
  transport: Transport,
  args: { accountId: string; body: UpdateAccountRequest },
): Promise<void> {
  return transport<void>({
    method: "PATCH",
    path: `/auth/accounts/${args.accountId}`,
    body: args.body,
    telemetry: { route: "/auth/accounts/{accountId}", method: "PATCH" },
  });
}

/**
 * `DELETE /auth/accounts/{accountId}`
 *
 * Account deleted successfully
 */
export function deleteAccounts(transport: Transport, args: { accountId: string }): Promise<void> {
  return transport<void>({
    method: "DELETE",
    path: `/auth/accounts/${args.accountId}`,
    telemetry: { route: "/auth/accounts/{accountId}", method: "DELETE" },
  });
}

/**
 * `POST /auth/accounts/{accountId}/devices/revive`
 *
 * Success - No Content
 */
export function postAccountsDevicesRevive(
  transport: Transport,
  args: { accountId: string; body: ReviveDeviceRequest },
): Promise<void> {
  return transport<void>({
    method: "POST",
    path: `/auth/accounts/${args.accountId}/devices/revive`,
    body: args.body,
    telemetry: { route: "/auth/accounts/{accountId}/devices/revive", method: "POST" },
  });
}

/**
 * `POST /auth/accounts/{accountId}/devices/wakeup`
 *
 * Success - No Content
 */
export function postAccountsDevicesWakeup(
  transport: Transport,
  args: { accountId: string; body: PTTWakeUpRequest },
): Promise<void> {
  return transport<void>({
    method: "POST",
    path: `/auth/accounts/${args.accountId}/devices/wakeup`,
    body: args.body,
    telemetry: { route: "/auth/accounts/{accountId}/devices/wakeup", method: "POST" },
  });
}

/**
 * `PUT /auth/accounts/{accountId}/pushnotificationdevices`
 *
 * Success - No Content
 */
export function putAccountsPushnotificationdevices(
  transport: Transport,
  args: { accountId: string; body: UpdatePushNotificationRequest },
): Promise<void> {
  return transport<void>({
    method: "PUT",
    path: `/auth/accounts/${args.accountId}/pushnotificationdevices`,
    body: args.body,
    telemetry: { route: "/auth/accounts/{accountId}/pushnotificationdevices", method: "PUT" },
  });
}

/**
 * `GET /auth/login`
 *
 * Login page HTML
 */
export function getLogin(
  transport: Transport,
  args: {
    returnTo?: string;
    authMethod?: string;
    email?: boolean;
    phone?: boolean;
    social?: boolean;
    validDomains?: string;
  } = {},
): Promise<void> {
  return transport<void>({
    method: "GET",
    path: "/auth/login",
    query: {
      returnTo: args.returnTo,
      authMethod: args.authMethod,
      email: args.email,
      phone: args.phone,
      social: args.social,
      validDomains: args.validDomains,
    },
    telemetry: { route: "/auth/login", method: "GET" },
  });
}

/**
 * `GET /auth/login/auth0`
 */
export function getLoginAuth0(
  transport: Transport,
  args: { returnTo?: string; identifier?: string; connection?: string; authMethod?: string; surface?: string } = {},
): Promise<void> {
  return transport<void>({
    method: "GET",
    path: "/auth/login/auth0",
    query: {
      returnTo: args.returnTo,
      identifier: args.identifier,
      connection: args.connection,
      authMethod: args.authMethod,
      surface: args.surface,
    },
    telemetry: { route: "/auth/login/auth0", method: "GET" },
  });
}

/**
 * `GET /auth/login/auth0/callback`
 */
export function getLoginAuth0Callback(transport: Transport, args: { state: string; code: string }): Promise<void> {
  return transport<void>({
    method: "GET",
    path: "/auth/login/auth0/callback",
    query: { state: args.state, code: args.code },
    telemetry: { route: "/auth/login/auth0/callback", method: "GET" },
  });
}

/**
 * `POST /auth/login/auth0/tokenexchange`
 *
 * Token exchange successful
 */
export function postLoginAuth0Tokenexchange(
  transport: Transport,
  args: { body: TokenExchangeRequest },
): Promise<TokenExchangeResponse> {
  return transport<TokenExchangeResponse>({
    method: "POST",
    path: "/auth/login/auth0/tokenexchange",
    body: args.body,
    telemetry: { route: "/auth/login/auth0/tokenexchange", method: "POST" },
  });
}

/**
 * `POST /auth/login/geotab`
 *
 * Login successful
 */
export function postLoginGeotab(
  transport: Transport,
  args: { body: GeotabLoginRequest },
): Promise<GeotabLoginResponse> {
  return transport<GeotabLoginResponse>({
    method: "POST",
    path: "/auth/login/geotab",
    body: args.body,
    telemetry: { route: "/auth/login/geotab", method: "POST" },
  });
}

/**
 * `POST /auth/login/isaac/direct`
 *
 * Login successful
 */
export function postLoginIsaacDirect(
  transport: Transport,
  args: { body: IsaacLoginRequest },
): Promise<IsaacLoginResponse> {
  return transport<IsaacLoginResponse>({
    method: "POST",
    path: "/auth/login/isaac/direct",
    body: args.body,
    telemetry: { route: "/auth/login/isaac/direct", method: "POST" },
  });
}

/**
 * `POST /auth/login/isaac/web`
 */
export function postLoginIsaacWeb(
  transport: Transport,
  args: { returnTo?: string; body: IsaacLoginRequest },
): Promise<void> {
  return transport<void>({
    method: "POST",
    path: "/auth/login/isaac/web",
    query: { returnTo: args.returnTo },
    body: args.body,
    telemetry: { route: "/auth/login/isaac/web", method: "POST" },
  });
}

/**
 * `POST /auth/login/ps/direct`
 *
 * Login successful
 */
export function postLoginPsDirect(
  transport: Transport,
  args: { body: PlatformScienceLoginRequest },
): Promise<PlatformScienceLoginResponse> {
  return transport<PlatformScienceLoginResponse>({
    method: "POST",
    path: "/auth/login/ps/direct",
    body: args.body,
    telemetry: { route: "/auth/login/ps/direct", method: "POST" },
  });
}

/**
 * `GET /auth/login/token`
 */
export function getLoginToken(transport: Transport, args: { token: string; returnTo?: string }): Promise<void> {
  return transport<void>({
    method: "GET",
    path: "/auth/login/token",
    query: { token: args.token, returnTo: args.returnTo },
    telemetry: { route: "/auth/login/token", method: "GET" },
  });
}

/**
 * `GET /auth/logout`
 */
export function getLogout(transport: Transport, args: { returnTo?: string } = {}): Promise<void> {
  return transport<void>({
    method: "GET",
    path: "/auth/logout",
    query: { returnTo: args.returnTo },
    telemetry: { route: "/auth/logout", method: "GET" },
  });
}

/**
 * `POST /auth/qr-login-token`
 *
 * Short-lived, single-use QR login token for the authenticated account
 */
export function postQrLoginToken(transport: Transport): Promise<QrLoginTokenResponse> {
  return transport<QrLoginTokenResponse>({
    method: "POST",
    path: "/auth/qr-login-token",
    telemetry: { route: "/auth/qr-login-token", method: "POST" },
  });
}

/**
 * `POST /auth/qr-login/redeem`
 *
 * Session token for the account the QR login token was minted for
 */
export function postQrLoginRedeem(
  transport: Transport,
  args: { body: QrLoginRedeemRequest },
): Promise<QrLoginRedeemResponse> {
  return transport<QrLoginRedeemResponse>({
    method: "POST",
    path: "/auth/qr-login/redeem",
    body: args.body,
    telemetry: { route: "/auth/qr-login/redeem", method: "POST" },
  });
}

/**
 * `GET /auth/refresh`
 *
 * Session refreshed successfully
 */
export function getRefresh(transport: Transport): Promise<{ message: string }> {
  return transport<{ message: string }>({
    method: "GET",
    path: "/auth/refresh",
    telemetry: { route: "/auth/refresh", method: "GET" },
  });
}

/**
 * `GET /auth/userinfo`
 *
 * User information retrieved successfully
 */
export function getUserinfo(transport: Transport): Promise<UserInfoResponse> {
  return transport<UserInfoResponse>({
    method: "GET",
    path: "/auth/userinfo",
    telemetry: { route: "/auth/userinfo", method: "GET" },
  });
}
